import { ThemeOptions } from '@mui/material';
import { createTheme } from './createTheme';

export const nextGenThemeOptions: ThemeOptions = {
    palette: {
        primary: {
            main: '#004aad', // Navy Blue
            dark: '#003885', // Darker Navy Blue
            light: '#6f8bcb', // Lighter Navy Blue
        },
        secondary: {
            main: '#A8A9AD', // Metallic Silver
            dark: '#8a8c8e', // Darker Metallic Silver
            light: '#c4c6c8', // Lighter Metallic Silver
        },
        neutral: {
            main: '#A8A9AD', // Metallic Silver
            contrastText: '#000814', // Rich Black
        },
        error: {
            main: '#DC3545', // Crimson Red
            dark: '#c62828', // Darker Crimson Red
            light: '#ff5f5f', // Lighter Crimson Red
        },
        info: {
            main: '#007BFF', //Deep Sky Blue
        },
        background: {
            paper: '#F4F4F4', // Off-White
            default: '#E9ECEF', //Soft Gray
        },
        text: {
            primary: '#000814', //Rich Black
            secondary: '#A8A9AD', // Metallic Silver
        },
        market: {
            up: '#18C673',
            down: '#FF2B6C', // Crimson Red
        },
        action: {
            active: '#A8A9AD', // Use secondary color for active state
            hover: '#E9ECEF', // Soft Gray
            activatedOpacity: 0.5,
        },
        common: {
            blue: '#007BFF', // Deep Sky Blue
            red: '#DC3545', // Crimson Red
            green: '#18C673', // Green
        },
        consensus: {
            strongSell: '##FF2B6C',
            sell: '#FF2B6C',
            hold: '#54A1E5',
            buy: '#18C673',
            strongBuy: '#18C673',
        },
        accountClassification: {
            cash: '#18C673',
            margin: '#E5B000',
            crypto: '#E07B1D',
            ira: '#1D41F6',
            dayTrader: '#FF2B6C',
        },
        divider: '#E3EAED',
        analystRatings: {
            success: '#18C673',
            fail: '#FF2B6C',
            successBorder: '#18C673',
            failBorder: '#FF2B6C',
            topPercentageBadge: '#F1F5F9',
        },
        optionChain: {
            held: '#18C673',
            attention: '#36a2eb',
            strike: '#54A1E5',
        },
    },
    shape: {
        borderRadius: 6,
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    border: '1px solid #E3EAED',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#C6D5DC',
                    color: '#1D2122',
                },
                arrow: {
                    color: '#C6D5DC',
                },
            },
        },
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F1F5F9',
                },
            },
        },
    },
};

export const nextGenTheme = createTheme(nextGenThemeOptions);
